import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { flattenHTMLToAppURL } from '@plone/volto/helpers/Url/Url';
import {
  PageHeader,
  InfoBox,
  RichText,
  PageMetadata,
} from '@redturtle/iovisit-theme/components/Views';
import Contacts from '@redturtle/iovisit-theme/components/Blocks/Contacts/Body';

const messages = defineMessages({
  timetable: { id: 'timetable', defaultMessage: 'Orari' },
  accomodationType: {
    id: 'accomodation_type',
    defaultMessage: 'Tipologia di struttura',
  },
  services: {
    id: 'services',
    defaultMessage: 'Servizi',
  },
  contacts: {
    id: 'contacts',
    defaultMessage: 'Contatti',
  },
  opening_type: {
    id: 'opening_type',
    defaultMessage: 'Apertura',
  },
  rooms: {
    id: 'rooms',
    defaultMessage: 'Stanze',
  },
  beds: {
    id: 'beds',
    defaultMessage: 'Letti',
  },
  housing_units: {
    id: 'housing_units',
    defaultMessage: 'Unità abitative',
  },
});

const VocabularyField = ({ title, content }) =>
  content?.length > 0 ? (
    <>
      {title && <h3>{title}</h3>}
      <p>{content.map((t) => t.title).join(', ')}</p>
    </>
  ) : null;

const AccomodationView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const services = VocabularyField({
    title: intl.formatMessage(messages.services),
    content: content.services,
  });

  const infoBoxHasData = !!timetable;
  const showAccomodationInfo =
    content.accomodation_type ||
    !!content.classification ||
    !!content.rooms ||
    !!content.beds ||
    !!content.housing_units;

  return (
    <div id="page-accomodation" className="ui container">
      {infoBoxHasData && (
        <InfoBox>
          <div>{timetable}</div>
          {content.opening_type && (
            <div>
              <strong>{intl.formatMessage(messages.opening_type)}: </strong>
              {content.opening_type}
            </div>
          )}
        </InfoBox>
      )}

      {showAccomodationInfo && (
        <>
          <h3>{intl.formatMessage(messages.accomodationType)}</h3>
          {content.accomodation_type && (
            <p>{content.accomodation_type.title}</p>
          )}
          {!!content.classification && <p>{content.classification}</p>}
          {!!content.rooms && (
            <p>
              <strong>{intl.formatMessage(messages.rooms)}: </strong>
              {content.rooms}
            </p>
          )}
          {!!content.beds && (
            <p>
              <strong>{intl.formatMessage(messages.beds)}: </strong>
              {content.beds}
            </p>
          )}
          {!!content.housing_units && (
            <p>
              <strong>{intl.formatMessage(messages.housing_units)}: </strong>
              {content.housing_units}
            </p>
          )}
        </>
      )}
      {services}

      {content.text?.data?.replace(/(<([^>]+)>)/g, '')?.length > 0 && (
        <>
          <hr />
          <div
            dangerouslySetInnerHTML={{
              __html: flattenHTMLToAppURL(content.text.data),
            }}
          />
        </>
      )}
      <hr />
      <Contacts properties={content} />
      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default AccomodationView;
